var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeselect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/DeselectAll@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-25.000000, -139.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/DeselectAll",
    transform: "translate(26.004576, 140.003014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Media-Library",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 13 3 13 3 3 13.9951302 3 13.9951302 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3 16 16.9951302 16 16.9951302 3 3 3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close",
    transform: "translate(4.545676, 3.996986)",
    strokeLinecap: "square",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Plus",
    transform: "translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) translate(1.610913, 1.610913)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.8890873,
    y1: 6.25935316e-15,
    x2: 3.8890873,
    y2: 7.77817459,
    id: "Stroke-1-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5.83952777e-14,
    y1: 3.8890873,
    x2: 7.77817459,
    y2: 3.8890873,
    id: "Stroke-3-Copy"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeselect);
export default __webpack_public_path__ + "static/media/Deselect.e0e908a470d3da87dd8958a4b60c65c3.svg";
export { ForwardRef as ReactComponent };